import { UseFormGetValues, UseFormWatch } from "react-hook-form"
import { ExpertiseType } from "../Schemas/ResumeSchemas"
import { useCallback } from "react";
import { TalentSpecializations } from "../Types/General";

export enum SpecializationView {
    'EditTalentProfile' = 1,
    'ProfileCreation'
}
interface useSpecializationsProps {
    watch: UseFormWatch<any>;
    getValues: UseFormGetValues<any>;
    view: SpecializationView
}

export const useSpecializations = ({ watch, getValues, view }: useSpecializationsProps) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    // I don't like having these hardcoded, too tightly couples the hook to the caller
    // TODO: Make this more super awesome and cool
    const labels =  view === SpecializationView.EditTalentProfile ? {
        Specialization: 'Specialization',
        Primary: 'PrimaryExpertise',
        Secondary: 'SecondaryExpertise',
        Teritary: 'TertiaryExpertise'
    } : {
        Specialization: 'specialization',
        Primary: 'primaryExpertise',
        Secondary: 'secondaryExpertise',
        Teritary: 'tertiaryExpertise'
    }
    /* ******************** Functions ******************** */
    const getExcludeList = useCallback((field: string) => {
        let primaryExpertise = getValues(labels.Primary),
            secondaryExpertise = getValues(labels.Secondary),
            tertiaryExpertise = getValues(labels.Teritary);

        switch (field) {
            case labels.Primary:
                return [secondaryExpertise, tertiaryExpertise];
            case labels.Secondary:
                return [primaryExpertise, tertiaryExpertise];
            case labels.Teritary:
                return [primaryExpertise, secondaryExpertise];
        }

        return [];
    }, [watch(labels.Specialization), watch(labels.Primary), watch(labels.Secondary), watch(labels.Teritary)]);
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return {
        getExcludeList
    }
}